import React, { FC } from 'react';
import styled from 'styled-components';
import { HelpIcon, HelpIconContainer } from '../helpIconContainer';

interface SelectionProps {
    tip?: React.ReactElement<any>;
    label: string;
    icon: React.ReactElement<any>;
    onClick?: () => void;
    children?: React.ReactNode;
    isPod?: boolean;
    disabled?: boolean;
}
const ImageContainer = styled.div<{ $isPod?: boolean }>`
    background-color: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    height: 70%;
    min-width: 80px;
    margin: auto;
    border-radius: 10px;
    ${(props) => (props.$isPod ? 'svg{}' : 'svg{transform: translateY(-25px)}')}
`;

const SelectionLabel = styled.div<{ disabled?: boolean }>`
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: ${(props) => props.theme.app.component.card.title.size};
    font-weight: ${(props) => props.theme.app.component.card.title.weight};
    color: ${(props) => props.theme.app.component.card.title.color};
    gap: 10px;

    ${(props) =>
        props.disabled &&
        `
			color: rgb(143, 164, 175);
	`}
`;

const SelectionContainer = styled.div<{ $isPod?: boolean; disabled?: boolean }>`
    display: flex;
    flex-direction: column;
    height: 200px;
    width: 100%;
    margin: auto;
    position: relative;
    border-radius: 8px;
    background: #ffffff;
    border: 1px solid #dbe2e6;
    padding: 20px;
    ${(props) => (props.$isPod ? 'justify-content: center;' : '')}

    ${(props) =>
        props.disabled &&
        `
			background: #ffffff;
			border: 1px solid #dbe2e6;
			color: rgb(143, 164, 175);
	`}

	${(props) =>
        !props.disabled &&
        `
	&:hover {
		cursor: pointer;
			box-shadow: 0px 0px 3px rgba(0, 0, 0, 0.1), 0px 4px 20px rgba(0, 0, 0, 0.15);
	}
	`}
`;

export const SelectionType: FC<SelectionProps> = (props) => {
    return (
        <SelectionContainer $isPod={props.isPod} onClick={props.onClick} disabled={props.disabled}>
            <ImageContainer $isPod={props.isPod}>{props.icon}</ImageContainer>

            {props.label && (
                <SelectionLabel disabled={props.disabled}>
                    {props.label}
                    {props.tip && (
                        <HelpIconContainer tooltip={props.tip}>
                            <HelpIcon />
                        </HelpIconContainer>
                    )}
                </SelectionLabel>
            )}
        </SelectionContainer>
    );
};

const SelectionTypeContainerContent = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fit, 330px);
    grid-gap: 30px;
    justify-content: center;
    align-items: center;
    margin: auto;
    padding-top: 20px;
`;

export const SelectionTypeContainer = ({ children }: { children: React.ReactNode }) => {
    return <SelectionTypeContainerContent>{children}</SelectionTypeContainerContent>;
};
